export enum ProgramUsageTab {
  DATA = 'data',
  DASHBOARD = 'dashboard',
  OUTPUT = 'output',
}
